import styled from "styled-components"

import Photo0201 from "../../img/02_01.jpg"
import Photo0202 from "../../img/02_02.jpg"
import Photo0203 from "../../img/02_03.jpg"

const Content01Back = styled.div`
  background: #000;
  width: 100%;
  height: 100%;
`

function SubMenuContent02() {
  return (
    <Content01Back>
      <div className="typotitle">HONDA CR-V</div>
      <div className="typobase03">
        혼다코리아에서 메인광고 제작의뢰로 만든 CR-V 광고입니다잡지와 신문 전면
        광고를 목적으로 영국에서 제작되었던 -Do More New-의 한국버전으로 동대문
        DDP를 배경으로 제작하였습니다. 2명의 디자이너와 1명의 카피라이터 팀으로
        며칠간의 아이디어 회의와 10번의 ABC안으로 반복된 시안, CG사의 리터칭으로
        최종 인쇄광고를 완성하였습니다. CRV의 실질적인 고연비를 어필하는
        방법으로 시공간 이동을 컨셉으로 다른 공간에서 DDP로 오는 메세지를 가진
        광고입니다.
      </div>
      <img src={Photo0201} className="photobase" alt="Photo0201"></img>
      <div className="typotitle">Adtive Innovation Cultural-life</div>
      <div className="typobase03">
        본 영상은 문화생활앱을 구글플레이에 올리는 광고물입니다. 포인트 적립형
        광고앱으로 문화원시인을 컨셉으로 문화활동을 못하는 원시인을 이 앱으로
        문화스타를 만들어내는 메세지를 담았습니다. 2명의 디자이너와 1명의
        카피라이터의 팀으로 제작 되었습니다.
      </div>
      <div className="video-wrap">
        <iframe
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/e31r9MAC9pM"
          frameBorder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <img src={Photo0202} className="photobase" alt="Photo0201"></img>
      <div className="typotitle">Metlife Inside PR Video</div>
      <div className="typobase03">
        메트라이프 내부 PR 의뢰로 만든 의뢰로 만든 영상입니다. 메트라이프 장기
        근로자들을 모델로 십여년전 처음 입사했을때의 꿈이 현재까지도 계속
        이어간다는 메세지가 담긴 PR 영상입니다. 2명의 디자이너와 1명의
        카피라이터의 팀으로 제작 되었습니다.
      </div>
      <div className="video-wrap">
        <iframe
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/V6EqjSXQE2c"
          frameBorder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <img src={Photo0203} className="photobase" alt="Photo0201"></img>
    </Content01Back>
  )
}

export default SubMenuContent02
